<template>
  <v-carousel
    cycle
    hide-delimiter-background
    show-arrows-on-hover
    height="auto"
  >
    <!-- Pictures -->
    <v-carousel-item v-for="(picture, index) in pictures" :key="index">
      <v-img :src="picture.PictureUrl" :aspect-ratio="1.618" width="100%" />
    </v-carousel-item>

    <!-- sold out text -->
    <template v-if="!hasCapacity(product, selectedItem)">
      <div class="sold-out-label-box" />
      <div
        class="sold-out-label-text"
        v-text="$translate('PRODUCT_SOLD_OUT')"
      />
    </template>

    <!-- Highlighting label -->
    <HighlightingLabel
      v-if="selectedItem"
      :label="selectedItem.HighlightingLabel"
      :visible="selectedItem.Highlighted"
    />

    <!-- Favorite Icon -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          small
          outlined
          color="red accent-3"
          class="favourite-icon"
          style="background-color: white"
          v-bind="attrs"
          v-on="on"
          @click="toggleFavourite"
        >
          <v-icon color="red accent-3" small>
            {{ favouriteIcon }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $translate('ADD_FAVORITE') }}</span>
    </v-tooltip>
  </v-carousel>
</template>

<script>
import uiHelpers from '@/shared/ui_helpers';
import UserObject from '@/objects/UserObject';
import { hasCapacity } from '@/objects/Product';
import HighlightingLabel from '@/components/generalComponents/HighlightingLabel';

export default {
  mixins: [uiHelpers],
  name: 'ProductMedia',
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    selectedItem: Object,
  },
  components: {
    HighlightingLabel,
  },
  data() {
    return {};
  },
  computed: {
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
    pictures() {
      let picturesTmp = [];

      if (
        this.selectedItem != null &&
        this.selectedItem.PictureUrl != null &&
        this.selectedItem.PictureUrl.trim() !== ''
      ) {
        picturesTmp.push({ PictureUrl: this.selectedItem.PictureUrl });
      } else if (this.product.Pictures != null) {
        picturesTmp = [...this.product.Pictures];
      }

      return picturesTmp;
    },
    favouriteProductIds() {
      const favouriteMap = this.$store.getters['user/favourites'];
      if (
        favouriteMap == null ||
        favouriteMap.Products == null ||
        favouriteMap.Products.length === 0
      ) {
        return [];
      }

      const prodIds = [];
      favouriteMap.Products.forEach((product) => prodIds.push(product.Id));

      return prodIds;
    },
    favouriteIcon() {
      if (
        this.favouriteProductIds == null ||
        this.favouriteProductIds.length === 0
      ) {
        return 'favorite_border';
      }

      if (this.favouriteProductIds.includes(this.product.Id)) {
        return 'favorite';
      }

      return 'favorite_border';
    },
    onDiscount() {
      // General discount check
      if (this.selectedItem != null && this.selectedItem.Discount) {
        return true;
      }

      // Personal discount check
      // if (this.personalDiscount > 0) {
      //   return true;
      // }
      return false;
    },
    personalDiscount() {
      const partnerId = this.product.PartnerId;
      const relations = this.partnerUserRelations[partnerId];
      if (
        relations != null &&
        relations.DiscountPercentage != null &&
        relations.DiscountPercentage > 0
      ) {
        return relations.DiscountPercentage;
      }
      return 0;
    },
    partnerUserRelations() {
      return this.$store.getters['auth/partnerUserRelations'];
    },
  },
  methods: {
    hasCapacity,
    goToLogin() {
      window.EventBus.fire('triggerOpenAccountFromMenu', {
        toggle: true,
        component: 'Login',
      });
    },
    toggleFavourite() {
      // Check if user is logged in
      if (!this.userLoggedIn) {
        this.goToLogin();

        return;
      }

      // If product-id is within the user favourites,
      // the user wants to delete the favourite, else user wants to add
      if (this.favouriteProductIds.includes(this.product.Id)) {
        this.deleteFavourite();
      } else {
        this.addFavourite();
      }
    },
    deleteFavourite() {
      UserObject.deleteFavourite(this.product.Id, 'Product');
    },
    addFavourite() {
      UserObject.addFavourite(this.product.Id, 'Product');
    },
  },
};
</script>

<style scoped lang="scss">
.sold-out-label-box {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(192, 192, 192, 0.5);
}
.sold-out-label-text {
  position: absolute;
  top: 0;
  left: 0;
  display: inline;
  background-color: #ff3333;
  color: white;
  font-weight: bold;
  font-size: 14px;
  padding: 4px 8px;
}
.favourite-icon {
  position: absolute;
  top: 16px;
  right: 16px;
}
</style>
